<template>
    <div class="d-flex">
        <ButtonComp
            v-if="row?.EngineDetails?.Name === 'ScoringEngine' || row?.EngineDetails?.Name === 'CacheManager'"
            button-type="Custom"
            :title="$tm('enginehandler.reloadinengine')"
            icon="fa-sync"
            @click="removeOrReloadFromEngine(true)"
        />

        <ButtonComp
            v-else
            button-type="Custom"
            :title="$tm('enginehandler.removefromengine')"
            icon="fa-trash-xmark"
            class="text-danger"
            @click="removeOrReloadFromEngine(false)"
        />

        <!-- This is not yet implementet. But here we will be able to get a dropdown with all the RankingEngines available so we can move it to another -->
        <ButtonComp
            v-if="false && row?.EngineDetails?.Name === 'RankingEngine'"
            :title="$tm('enginehandler.changeengine')"
            button-type="Custom"
            icon="fa-shuffle"
            @click="changeEngine"
        />
    </div>
</template>
<script lang="ts" setup>
import { ButtonComp } from '@/components';
import { useDialog } from '@/composeables';
import { EventEngineDao } from '@/dao';
import { $tm } from '@/locize';
import type { EngineEvent } from '@/objects/generated';
import { useEventStoreRef, useToastStore } from '@/stores';
import { ref } from 'vue';

const props = defineProps<{
    value: number;

    row?: EngineEvent;
}>();

const { eventID } = useEventStoreRef();

const rowvalue = ref(props.row);

/**
 * Remove the current event from the engine
 */
const removeOrReloadFromEngine = (reload: boolean = false) => {
    if (!props.row) {
        return;
    }

    let title = reload ? 'enginehandler.reloadinengine' : 'enginehandler.removefromengine';
    let content = reload ? 'enginehandler.reloadinenginetext' : 'enginehandler.removefromenginetext';
    let toast = reload ? 'enginehandler.reloadinenginesuccess' : 'enginehandler.removedfromenginesuccess';

    useDialog().YesNo({
        title: $tm(title),
        body: $tm(content, '', true),
        yesCallback: async () => {
            await EventEngineDao.RemoveEventFromEngine(eventID.value, props.row?.EngineDetails?.Name!, props.row?.EngineDetails?.Address!);

            // We trigger a change in the value to force a reload
            if (rowvalue.value) {
                rowvalue.value.EventID = 0;
            }

            useToastStore().addSuccess($tm(toast));

            return true;
        },
    });
};

/**
 * Change the engine
 * NOTE! This is only available for RankingEngines
 */
const changeEngine = () => {
    // TODO: This should be implemented
    console.log('Change engine');
};
</script>
